import HeroCarousel from '@/pages/home/components/HeroCarousel';
import QuickCategories from '@/pages/home/components/QuickCategories';
import HotToday from '@/pages/home/components/HotToday';
import TopicCollections from '@/pages/home/components/TopicCollections';
import SiteIntro from '@/pages/home/components/SiteIntro';

export default function Home() {
  return (
    <div className="flex w-full flex-col gap-14 pb-4">
      <section aria-label="精选推荐">
        <HeroCarousel />
      </section>

      <section aria-label="热点分类快捷入口">
        <QuickCategories />
      </section>

      <HotToday />

      <TopicCollections />

      <SiteIntro />
    </div>
  );
}